'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC } from 'react';
import Radio from '@/components/shared/Fields/radio';
import css from './style.module.scss';
export type ViewMode = 'grid' | 'table';
interface Props {
  selectedMode: ViewMode;
  onModeChange: (mode: ViewMode) => void;
}
const ListViewModeToggle: FC<Props> = t0 => {
  const $ = _c(17);
  const {
    selectedMode,
    onModeChange
  } = t0;
  const t1 = selectedMode === "grid";
  let t2;
  if ($[0] !== t1) {
    t2 = clsx(css.icon, {
      [css.selected]: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = {
      id: 1,
      value: "grid",
      label: <img src="/assets/icons/blog/grid-icon.svg" width={15} height={15} alt="" className={t2} />
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = selectedMode === "table";
  let t5;
  if ($[4] !== t4) {
    t5 = clsx(css.icon, {
      [css.selected]: t4
    });
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = {
      id: 2,
      value: "table",
      label: <img src="/assets/icons/blog/table-icon.svg" width={15} height={12} alt="" className={t5} />
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = [t3, t6];
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const options = t7;
  let t8;
  if ($[11] !== onModeChange) {
    t8 = value => onModeChange(value as 'grid' | 'table');
    $[11] = onModeChange;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== options || $[14] !== selectedMode || $[15] !== t8) {
    t9 = <div className={css.wrapper}><Radio multiple={false} selectedValue={selectedMode} options={options} onChange={t8} /></div>;
    $[13] = options;
    $[14] = selectedMode;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
export default ListViewModeToggle;